import React from 'react'

type Props = Readonly<{
  equalOdds: boolean
  marblesCount: number
  showSimpleOdds: boolean
  gameType?: string
  children: React.ReactNode
}>

export function MarblePaneMarbleWrapper({
  equalOdds,
  marblesCount,
  children,
  showSimpleOdds,
  gameType
}: Props) {
  return (
    <div
      className={`marbles-container game-marbles-${marblesCount} ${
        equalOdds || showSimpleOdds ? 'has-equal-odds' : ''
      } ${gameType ? `container-game-type-${gameType}` : ''}`}
    >
      {children}
    </div>
  )
}
